import { faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import ThemeContext from '../../../providers/ThemeProvider';

const SectionTitle = ({
  title,
  collapsed,
  onToggleCollapse,
  isSubCat,
  className,
}) => {
  const theme = useContext(ThemeContext);
  const isCollapsable = Boolean(onToggleCollapse);
  const onKeyDown = (event) => {
    if (isCollapsable && event.key === 'Enter') {
      onToggleCollapse();
    }
  };

  return (
    <>
      <div
        className={classNames('section-title', className)}
        onClick={onToggleCollapse}
        onKeyDown={onKeyDown}
        role={isCollapsable ? 'button' : null}
        tabIndex={isCollapsable ? 0 : -1}
      >
        <h2 className="section-title__content">{title}</h2>
        <div
          className={classNames('section-title__bar', {
            'section-title__bar--full-width': !isCollapsable,
          })}
        />
        {isCollapsable && (
          <FontAwesomeIcon
            className="section-title__icon"
            color={theme.colors.primary}
            icon={faChevronUp}
            style={{ transform: collapsed && `rotateZ(180deg)` }}
          />
        )}
      </div>
      <style jsx>{`
        .section-title {
          display: flex;
          align-items: center;
          width: 100%;
          margin-top: ${isSubCat ? '6px' : 'unset'};
          margin-bottom: ${isSubCat ? '6px' : '10px'};
        }
        .section-title__content {
          display: flex;
          align-items: center;
          margin: 0;
          font-size: ${isSubCat ? '20px' : 'unset'};
        }
        .section-title__bar {
          flex-grow: 1;
          height: ${isSubCat ? '0px' : '1px'};
          background-color: ${theme.colors.dealline};
          margin: 0 8px;
        }
        .section-title__bar--full-width {
          margin-right: 0;
        }
      `}</style>
    </>
  );
};

SectionTitle.propTypes = {
  className: PropTypes.string,
  collapsed: PropTypes.bool,
  onToggleCollapse: PropTypes.func,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
};

SectionTitle.defaultProps = {
  className: '',
  collapsed: false,
  onToggleCollapse: undefined,
  title: '',
};

export default SectionTitle;
